import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { groupStyles } from './styles';
import * as meta from '../../meta-data.json';

export const overrides = (props: any) => {
	const { ariaLabel, viewref, columnGap, disableKeyboardSupport, initialState, ...rest } = props;
	return {
		Root: {
			style: () => {
				return {
					...groupStyles(props),
				};
			},
			props: {
				...getBaseCustomProps(props),
				...rest,
				className: `${props.className} buttongroup`,
				//role: props.mode, // a11y-todo: role='radiogroup' or 'group'
				role: props.mode == 'radio' ? 'radio' : 'group',
				'data-epo': `epo-buttongroup-${meta.version}`,
				part: `epo-buttongroup-${meta.version}`,
				'aria-hidden': !props.children ? true : null,
			},
		},
	};
};
